import { createReducer } from '../../utilities';
import {
    REQUEST_FETCH_STATS_USER_CONNECTIONS,
    SUCCESS_FETCH_STATS_USER_CONNECTIONS,
    FAIL_FETCH_STATS_USER_CONNECTIONS,
} from "../../../actions/entities/statistics/userConnections";

const initialState = {
    data: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        data,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_FETCH_STATS_USER_CONNECTIONS]: requestFetch,
    [SUCCESS_FETCH_STATS_USER_CONNECTIONS]: successFetch,
    [FAIL_FETCH_STATS_USER_CONNECTIONS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/userConnections.js